/*
 * @FilePath: \hotOrder-frontend\src\router\modules\patrol.js
 * @Description: 巡查管理路由
 */
import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};

export default {
  path: "/patrol",
  name: "patrol",
  redirect: {
    name: "patrol",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/patrol/patrolList",
      name: "patrolList",
      meta: {
        ...meta,
        title: "巡查标准管理",
      },
      component: () => import("@/pages/patrol/patrolList.vue"),
    },
    {
      path: "/patrol/patrolLines",
      name: "patrolLines",
      meta: {
        ...meta,
        title: "巡查路线管理",
      },
      component: () => import("@/pages/patrol/patrolLines.vue"),
    },
    {
      path: "/patrol/patrolTemplateAdd",
      name: "patrolTemplateAdd",
      meta: {
        ...meta,
        title: "巡查标准新增",
      },
      component: () =>
        import("@/pages/patrol/components/PatrolTemplateAdd.vue"),
    },
    {
      path: "/patrol/patrolLinesSet",
      name: "patrolLinesSet",
      meta: {
        ...meta,
        title: "巡查路线",
      },
      component: () => import("@/pages/patrol/components/PatrolLinesSet.vue"),
    },
    {
      path: "/patrol/patrolLinesRecord",
      name: "patrolLinesRecord",
      meta: {
        ...meta,
        title: "巡查任务记录",
      },
      component: () => import("@/pages/patrol/patrolLinesRecord.vue"),
    },
    {
      path: "/patrol/patrolPeopleRecord",
      name: "patrolPeopleRecord",
      meta: {
        ...meta,
        title: "巡查人员记录",
      },
      component: () => import("@/pages/patrol/patrolPeopleRecord.vue"),
    },
    {
      path: "/patrol/patrolTaskRecord",
      name: "patrolTaskRecord",
      meta: {
        ...meta,
        title: "巡查任务情况",
      },
      component: () => import("@/pages/patrol/patrolTaskRecord.vue"),
    },
    {
      path: "/patrol/patrolGridRecord",
      name: "patrolGridRecord",
      meta: {
        ...meta,
        title: "网格员巡查情况",
      },
      component: () => import("@/pages/patrol/patrolGridRecord.vue"),
    },
    {
      path: "/patrol/PatrolDetail",
      name: "patrolDetail",
      meta: {
        ...meta,
        title: "巡查详情",
      },
      component: () => import("@/pages/patrol/components/PatrolDetail.vue"),
    },
    {
      path: "/patrol/specialPatrol",
      name: "specialPatrol",
      meta: {
        ...meta,
        title: "专项巡查管理",
      },
      component: () => import("@/pages/patrol/specialPatrol.vue"),
    },
    {
      path: "/patrol/specialPatrolAdd",
      name: "specialPatrolAdd",
      meta: {
        ...meta,
        title: "专项巡查管理新增",
      },
      component: () => import("@/pages/patrol/specialPatrolAdd.vue"),
    },
    {
      path: "/patrol/specialPatrolDetail",
      name: "specialPatrolDetail",
      meta: {
        ...meta,
        title: "专项巡查管理详情",
      },
      component: () => import("@/pages/patrol/specialPatrolDetail.vue"),
    },
    {
      path: "/patrol/patrolResultDetail",
      name: "patrolResultDetail",
      meta: {
        ...meta,
        title: "巡查结果详情",
      },
      component: () => import("@/pages/patrol/patrolResultDetail.vue"),
    },
  ],
};
